module.exports = __webpack_public_path__ + "assets/img/yunzhuji_22.42af82b9.gif";